import React from 'react';
import '../css/FreemiumCrestest.css';
import { FaArrowRight } from 'react-icons/fa';

const FreemiumCrestest = () => {
  return (
    <section className="freemium-band-section">
      <div className="freemium-band-overlay"></div>
      
      <div className="container freemium-band-container">
        <div className="freemium-band-content">
          <div className="freemium-band-text">
            <span className="freemium-band-badge">New to CRESTEST?</span>
            <h1 className="freemium-band-title">
              Start your journey with a zero-cost Diagnostic Test 
              {/* at <strong>crestestlearning.com</strong> */}
            </h1>
          </div>
          
          <a 
            href="https://crestestlearning.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="freemium-band-btn"
          >
            <span>Go to crestestlearning.com</span>
            {/* <FaArrowRight className="arrow-icon" /> */}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FreemiumCrestest;